import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import LlmConfigurationLayer from "../components/LlmConfigurationLayer";

const LlmConfigurationPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout pageTitle="LLM Configuration">

        {/* LLMConfigurationLayer */}
        <LlmConfigurationLayer />
      </MasterLayout>
    </>
  );
};

export default LlmConfigurationPage;
